import { configureStore, combineReducers } from '@reduxjs/toolkit'

import { activityReducer } from './Activity/store/reducer'
import activityNewReducer from './App/store/features/activity/reducer'
import blockCategoryNewReducer from './App/store/features/blockCategory/reducer'
import customerNewReducer from './App/store/features/customer/reducer'
import personReducer from './App/store/features/person/personSlice'
import { calendarReducer } from './Calendar/store/calendarSlice'
import errorHandlingReducer from './Common/ErrorHandling/store'
import { surveyReducer } from './Customer/Survey/Store/Reducer'
import { establishmentReducer } from './Establishment/Store/reducer'
import { healthInsuranceReducer } from './HealthInsuranceN/store/reducer'
import { holidayReducer } from './HR/Absence/Holiday/Store/Reducer'
import { absenceReducer } from './HR/Absence/Store/Reducer'
import { absenceRequestReducer } from './HR/AbsenceRequests/Store/Reducer'
import { knowledgeRequestReducer } from './HR/Knowledge/Store/Reducer'
import { personTargetsReducer } from './HR/PersonTargets/Store/Reducer'
import { punchlcockReducer } from './HR/Punchclock/Store/Reducer'
import { lastMinuteReducer } from './LegacyCalendar/LastMinute/Store/Reducer'
import { trashCanReducer } from './LegacyCalendar/TrashCan/store/Reducer'
import { waitingListReducer } from './LegacyCalendar/WaitingList/store/Reducer'
import { notificationReducer } from './Menu/Notification/store/reducer'
import { preferencesReducer } from './Preference/Store/reducer'
import { productReducer } from './Product/Store/Reducer'
import referralReducer from './Referral/reducer'
import { expensesReducer } from './Report/ExpensesReport/Store/Reducer'
import { performanceReducer } from './Report/PerformanceReport/Store/Reducer'
import { skinTrackReducer } from './SkinTrack/Store/Reducer'
import { subscriptionReducer } from './Subscription/store/reducer'
import { permissionReducer } from './User/Permission/Store/Reducer'
import { userReducer } from './User/Store/reducer'
import { hrUsersReducer } from './User/UsersHr/Store/Reducer'

const rootReducer = combineReducers({
  errorHandling: errorHandlingReducer,
  preferences: preferencesReducer,
  activities: activityReducer,
  establishment: establishmentReducer,
  users: userReducer,
  notifications: notificationReducer,
  absences: absenceReducer,
  holidays: holidayReducer,
  lastMinutes: lastMinuteReducer,
  userPermissions: permissionReducer,
  punchclock: punchlcockReducer,
  healthInsurance: healthInsuranceReducer,
  subscriptionPlan: subscriptionReducer,
  calendar: combineReducers({
    trashCan: trashCanReducer,
    waitingList: waitingListReducer,
  }),
  hr: combineReducers({
    personTargets: personTargetsReducer,
    absenceRequests: absenceRequestReducer,
    hrUsers: hrUsersReducer,
    knowledgeRequests: knowledgeRequestReducer,
  }),
  customers: combineReducers({
    surveys: surveyReducer,
  }),
  products: productReducer,
  reports: combineReducers({
    performanceReports: performanceReducer,
    expenses: expensesReducer,
  }),
  skin_tracks: skinTrackReducer,
  calendarNew: calendarReducer,
  personNew: personReducer,
  activityNew: activityNewReducer,
  customerNew: customerNewReducer,
  blockCategory: blockCategoryNewReducer,
  referral: referralReducer,
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
